<template>
  <v-card flat>
    <v-overlay v-if="deleting" absolute :opacity="0.7">
      <div class="text-center">
        <v-progress-circular :size="30" indeterminate></v-progress-circular>
        <div class="caption mt-4">Deleting File</div>
      </div>
    </v-overlay>

    <v-card-text v-if="tab.description" class="grey lighten-4">
      <p>{{ tab.description }}</p>
    </v-card-text>

    <v-divider v-if="tab.description"></v-divider>

    <section v-if="!tab.files.length">
      <v-container>
        <v-row align="center">
          <v-col cols="12" class="py-12 text-center">
            <h4 class="text--secondary">
              No videos available
              <v-icon>fa-frown</v-icon>
            </h4>
          </v-col>
        </v-row>
      </v-container>
    </section>

    <section class="scroll-box" v-if="tab.multiple">
      <v-container align="center" class="pa-0">
        <v-row align="center" :justify="tab.files.length ? 'start' : 'center'">
          <v-col
            cols="6"
            sm="4"
            v-for="(item, i) in tab.files"
            :key="`videos-${i}`"
          >
            <v-img :aspect-ratio="640 / 360" :src="item.thumbnail" class="ma-2">
              <v-btn
                class="item-delete"
                color="error"
                dark
                x-small
                style="width: 16px; height: 16px"
                fab
                @click="removeItem(item, $event)"
                v-if="!readonly"
              >
                <v-icon x-small>fa-times</v-icon>
              </v-btn>
              <v-overlay absolute v-if="!item.original_url">
                <v-progress-circular :size="80" indeterminate
                  ><span class="caption">Processing</span></v-progress-circular
                >
              </v-overlay>
              <v-overlay absolute v-else>
                <v-icon @click="$eventBus.$emit('play_video', item.url)"
                  >fa-play</v-icon
                >
              </v-overlay>
              <div></div>
            </v-img>
          </v-col>
        </v-row>
      </v-container>
    </section>

    <v-container v-else class="pa-0">
      <v-row justify="center">
        <v-col
          cols="12"
          class="py-0"
          v-for="(item, u) in tab.files"
          :key="`video-${u}`"
        >
          <v-overlay absolute v-if="!item.original_url">
            <v-progress-circular :size="100" indeterminate
              ><span class="caption">Processing</span></v-progress-circular
            >
          </v-overlay>
          <video
            playsinline
            style="
              width: 100%;
              height: auto;
              max-height: 66vh;
              margin-bottom: -8px;
            "
            :src="item.url"
            :poster="item.thumbnail"
            controls
          ></video>
          <div class="item-delete">
            <div>
              <v-btn
                v-if="!readonly"
                x-small
                color="error"
                dark
                fab
                @click="removeItem(item, $event)"
              >
                <v-icon x-small>fa-times</v-icon>
              </v-btn>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
export default {
  name: "PortalSectionVideoViewTab",
  props: ["value", "readonly"],
  data() {
    return {
      slide: "",
      deleting: false,
    };
  },
  computed: {
    tab() {
      return this.value;
    },
  },
  methods: {
    async removeItem(v, ev) {
      ev.preventDefault();
      if (!confirm("Sure you want to remove that item ?")) {
        return;
      }
      this.deleting = true;
      try {
        await this.$api.delete(`/user/portals/delete-upload`, {
          data: v,
        });
      } catch (ex) {
        alert(ex.error);
      }
      this.tab.files = this.tab.files.filter((item) => {
        return item !== v;
      });
      this.$emit("change");
      this.deleting = false;
    },
  },
};
</script>

<style scoped lang="scss">
.sheetbox {
  align-items: center;
  justify-content: center;
  display: flex;
}
.item-delete {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 201;
}
</style>